import { useNoteEntityRelationshipStyles } from './entity-relationship.styles';
import { KnownDeliveryState, KnownOrderStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { deliveryStateToColor } from '../../../../features/deliveries/maps/delivery-state-to-color.map';
import { deliveryStateToLabel } from '../../../../features/deliveries/maps/delivery-state-to-label.map';
import { StatusBadge } from '../status-badge/status-badge.component';
import { SVGIconComponent } from '../icons/types';
import { orderStatusBackgroundColors, orderStatusToLabel } from '../../../../features/orders/orders.constants';
import { Link } from 'react-router-dom';

export interface NoteEntityRelationshipProps {
  Icon: SVGIconComponent;
  label: string;
  deliveryStatus?: KnownDeliveryState;
  orderStatus?: KnownOrderStatus;
  path: string;
}

export function NoteEntityRelationship({
  Icon,
  label,
  deliveryStatus,
  orderStatus,
  path
}: NoteEntityRelationshipProps) {
  const classes = useNoteEntityRelationshipStyles();

  return (
    <Link to={path}>
      <div className={classes.root}>
        <div style={{ display: 'flex' }}>
          <div className={classes.icon}>{<Icon style={{ height: '20px', width: '20px' }} />}</div>
          <div className={classes.id}>
            <span>{label}</span>
          </div>
        </div>
        <div>
          {deliveryStatus ? (
            <StatusBadge
              label={deliveryStateToLabel[deliveryStatus]}
              cornerRounding="med"
              color={deliveryStateToColor[deliveryStatus]}
            />
          ) : orderStatus ? (
            <StatusBadge
              label={orderStatusToLabel[orderStatus]}
              cornerRounding="med"
              color={orderStatusBackgroundColors[orderStatus]}
            />
          ) : null}
        </div>
      </div>
    </Link>
  );
}
